export default __webpack_public_path__ + "files/media/home-ar-m.912cfc27.jpg";